import AbstractJourney from './abstract-journey.model'
import cloneDeep from 'lodash.clonedeep'

export default class StandardJourney extends AbstractJourney {
  constructor() {
    super(AbstractJourney.STANDARD)

    this.embarking = {}
    this.coupled_vehicle = {}

    this.border = ''
    this.countries = []
  }

  static restructured(journey) {
    let restructuredJourney = cloneDeep(journey)

    let restructuredGoods = [...new Array(3)].map(() => ({
      type: '',
      dangerous_type: '',
      aspect: '',
      loaded_weight: '',
      unloaded_weight: '',
      onboard_flag: false,
    }))

    if (journey.is_empty) {
      restructuredGoods[0].type = 0
      restructuredGoods[0].unloaded_weight = 0
    } else {
      journey.goods.forEach((item, index) => {
        const { type, dangerous_type, aspect, loaded_weight, unloaded_weight } = item
        restructuredGoods[index] = {
          type,
          dangerous_type,
          aspect,
          loaded_weight,
          unloaded_weight,
          onboard_flag: item.unloaded_weight === 0,
        }
      })
    }

    restructuredJourney.goods = restructuredGoods

    console.table(restructuredJourney.goods)

    return restructuredJourney
  }

  static getRecordColumns(journey, filler = '0') {
    let columns = []

    columns.push(`${journey.date.replace('/', '')}`.padStart(4, filler)) // data del viaggio GGMM
    columns.push(`${journey.coupled_vehicle.load_capacity}`.padStart(3, filler)) // portata utile rim. o semirimorchio
    columns.push(`${journey.coupled_vehicle.axles}`.padStart(1, filler)) // n. assi rim. o semirimorchio
    columns.push(`${journey.origin.place.cod_com ? journey.origin.place.cod_com : ''}`.padStart(3, filler)) // località di partenza/comune italiano
    columns.push(`${journey.origin.place.cod_prv ? journey.origin.place.cod_prv : ''}`.padStart(3, filler)) // località di partenza/provincia italiana
    columns.push(
      `${journey.origin.place.cod_prv_pse_esr ? journey.origin.place.cod_prv_pse_esr : ''}`.padStart(5, filler)
    ) // località di partenza/comune estero
    columns.push(
      `${journey.origin.place.cod_pse_esr_ue_eee ? journey.origin.place.cod_pse_esr_ue_eee : ''}`.padStart(2, filler)
    ) // località di partenza/stato estero ue+eee
    columns.push(
      `${journey.origin.place.cod_pse_es_extra_eu ? journey.origin.place.cod_pse_esr_extra_eu : ''}`.padStart(2, filler)
    ) // località di partenza/stato estero extra ue
    console.table(journey.goods)
    columns.push(`${journey.origin.type}`.padStart(1, filler)) // tipologia località di carico
    columns.push(`${journey.goods[0].type || ''}`.padStart(2, filler)) // merce caricata 1
    columns.push(`${journey.goods[1].type || ''}`.padStart(2, filler)) // merce caricata 2
    columns.push(`${journey.goods[2].type || ''}`.padStart(2, filler)) // merce caricata 3
    columns.push(`${journey.goods[0].dangerous_type}`.padStart(2, filler)) // merce pericolosa 1
    columns.push(`${journey.goods[1].dangerous_type}`.padStart(2, filler)) // merce pericolosa 2
    columns.push(`${journey.goods[2].dangerous_type}`.padStart(2, filler)) // merce pericolosa 3
    columns.push(`${journey.goods[0].loaded_weight}`.padStart(3, filler)) // peso merce 1
    columns.push(`${journey.goods[1].loaded_weight}`.padStart(3, filler)) // peso merce 2
    columns.push(`${journey.goods[2].loaded_weight}`.padStart(3, filler)) // peso merce 3
    columns.push(`${journey.goods[0].aspect}`.padStart(2, filler)) // aspetto del carico 1
    columns.push(`${journey.goods[1].aspect}`.padStart(2, filler)) // aspetto del carico 2
    columns.push(`${journey.goods[2].aspect}`.padStart(2, filler)) // aspetto del carico 3
    columns.push(`${journey.destination.place.cod_com ? journey.destination.place.cod_com : ''}`.padStart(3, filler)) // località di arrivo/comune italiano
    columns.push(`${journey.destination.place.cod_prv ? journey.destination.place.cod_prv : ''}`.padStart(3, filler)) // località di arrivo/provincia italiana
    columns.push(
      `${journey.destination.place.cod_prv_pse_esr ? journey.destination.place.cod_prv_pse_esr : ''}`.padStart(
        5,
        filler
      )
    ) // località di arrivo comune estero
    columns.push(
      `${journey.destination.place.cod_pse_esr_ue_eee ? journey.destination.place.cod_pse_esr_ue_eee : ''}`.padStart(
        2,
        filler
      )
    ) // località di arrivo/stato estero ue+eee
    columns.push(
      `${journey.destination.place.cod_pse_es_extra_eu ? journey.destination.place.cod_pse_es_extra_eu : ''}`.padStart(
        2,
        filler
      )
    ) // località di arrivo/stato estero extra ue
    columns.push(`${journey.destination.type}`.padStart(1, filler)) // tipologia località di scarico
    columns.push(`${journey.goods[0].onboard_flag ? 1 : 0}`.padStart(1, filler)) // merce a bordo di tipo 1
    columns.push(`${journey.goods[1].onboard_flag ? 1 : 0}`.padStart(1, filler)) // merce a bordo di tipo 2
    columns.push(`${journey.goods[2].onboard_flag ? 1 : 0}`.padStart(1, filler)) // merce a bordo di tipo 3
    columns.push(`${journey.goods[0].loaded_weight}`.padStart(3, filler)) // merce scaricata in qli di tipo 1
    columns.push(`${journey.goods[1].loaded_weight}`.padStart(3, filler)) // merce scaricata in qli di tipo 2
    columns.push(`${journey.goods[2].loaded_weight}`.padStart(3, filler)) // merce scaricata in qli di tipo 3
    columns.push(`${journey.distance}`.padStart(4, filler)) // distanza percorsa in km
    columns.push(`${journey.coupled_vehicle.type}`.padStart(1, filler)) // veicolo caricato su altro mezzo
    columns.push(
      `${
        journey.embarking.embarking_place && journey.embarking.embarking_place.cod_com
          ? journey.embarking.embarking_place.cod_com
          : ''
      }`.padStart(3, filler)
    ) // località di imbarco/comune italiano
    columns.push(
      `${
        journey.embarking.embarking_place && journey.embarking.embarking_place.cod_prv
          ? journey.embarking.embarking_place.cod_prv
          : ''
      }`.padStart(3, filler)
    ) // località di imbarco/provincia
    columns.push(
      `${
        journey.embarking.embarking_place && journey.embarking.embarking_place.cod_prv_pse_esr
          ? journey.embarking.embarking_place.cod_prv_pse_esr
          : ''
      }`.padStart(5, filler)
    ) // località di imbarco/comune estero
    columns.push(
      `${
        journey.embarking.embarking_place && journey.embarking.embarking_place.cod_pse_esr_ue_eee
          ? journey.embarking.embarking_place.cod_pse_esr_ue_eee
          : ''
      }`.padStart(2, filler)
    ) // località di imbarco/stato estero ue+eee
    columns.push(
      `${
        journey.embarking.embarking_place && journey.embarking.embarking_place.cod_pse_esr_extra_eu
          ? journey.embarking.embarking_place.cod_pse_esr_extra_eu
          : ''
      }`.padStart(2, filler)
    ) // località di imbarco/stato estero extra ue
    columns.push(
      `${
        journey.embarking.disembarking_place && journey.embarking.disembarking_place.cod_com
          ? journey.embarking.disembarking_place.cod_com
          : ''
      }`.padStart(3, filler)
    ) // // località di sbarco/comune italiano
    columns.push(
      `${
        journey.embarking.disembarking_place && journey.embarking.disembarking_place.cod_prv
          ? journey.embarking.disembarking_place.cod_prv
          : ''
      }`.padStart(3, filler)
    ) // località di sbarco/provincia
    columns.push(
      `${
        journey.embarking.disembarking_place && journey.embarking.disembarking_place.cod_prv_pse_esr
          ? journey.sembarking.disembarking_place.cod_prv_pse_esr
          : ''
      }`.padStart(5, filler)
    ) // località di sbarco/comune estero
    columns.push(
      `${
        journey.embarking.disembarking_place && journey.embarking.disembarking_place.cod_pse_esr_ue_eee
          ? journey.embarking.disembarking_place.cod_pse_esr_ue_eee
          : ''
      }`.padStart(2, filler)
    ) // località di sbarco/stato estero ue+eee
    columns.push(
      `${
        journey.embarking.disembarking_place && journey.embarking.disembarking_place.cod_pse_esr_extra_eu
          ? journey.embarking.disembarking_place.cod_pse_esr_extra_eu
          : ''
      }`.padStart(2, filler)
    ) // località di sbarco/stato estero extra ue
    columns.push(`${journey.border_crossed ? journey.border_crossed.code : ''}`.padStart(2, filler)) // punti di frontiera attraversati
    columns.push(
      `${journey.countries_crossed.length === 1 ? journey.countries_crossed[0].code : ''}`.padStart(2, filler)
    ) // stati attraversati 1
    columns.push(
      `${journey.countries_crossed.length === 2 ? journey.countries_crossed[1].code : ''}`.padStart(2, filler)
    ) // stati attraversati 2
    columns.push(
      `${journey.countries_crossed.length === 3 ? journey.countries_crossed[2].code : ''}`.padStart(2, filler)
    ) // stati attraversati 3
    columns.push(
      `${journey.countries_crossed.length === 4 ? journey.countries_crossed[3].code : ''}`.padStart(2, filler)
    ) // stati attraversati 4
    columns.push(
      `${journey.countries_crossed.length === 5 ? journey.countries_crossed[4].code : ''}`.padStart(2, filler)
    ) // stati attraversati 5
    columns.push(`${journey.is_ended ? 1 : 0}`.padStart(1, filler)) // fine viaggio
    columns.push(`${journey.num_via}`.padStart(3, filler)) // numero viaggio
    columns.push(`${journey.num_via_prg}`.padStart(3, filler)) // numero progressivo record per viaggio
    columns.push('?'.padStart(1, filler)) // è compilato lo schema circuiti

    return columns
  }
}
